// =============================================================================
// Date-only display (Dev audit F-11, 2026-10-19).
//
// `new Date('2026-10-19')` parses a bare date as MIDNIGHT UTC, so in any timezone west of UTC (every US
// user) `.toLocaleDateString()` renders the PREVIOUS day: a meal plan stored as starting 2026-10-19 showed
// "10/18/2026", and pantry expiry and medical-record dates were a day early too. The gate never saw it —
// EC2Dev, and so every browser test, runs in UTC.
//
// formatDateOnly() reads a bare 'YYYY-MM-DD' as a LOCAL calendar date. Anything else (a full timestamp,
// a Date) is passed to `new Date` unchanged, so it is safe on any field.
// =============================================================================

const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

export function parseDateOnly(value) {
  if (value instanceof Date) return value;
  if (typeof value === 'string') {
    const m = DATE_ONLY.exec(value.trim());
    if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  }
  return new Date(value);
}

export function formatDateOnly(value, options, locale) {
  if (value === null || value === undefined || value === '') return '';
  const d = parseDateOnly(value);
  return Number.isNaN(d.getTime()) ? String(value) : d.toLocaleDateString(locale, options);
}
